/** @jsxImportSource @emotion/react */
import { grey } from '@mui/material/colors'

import React from 'react'
import { View } from './View'

interface PropsType {
	className?: string
	style?: React.CSSProperties
}

export const Divider = (props: PropsType) => {
	return (
		<View
			css={[
				{
					marginTop: '1rem',
					marginBottom: '0.5rem',
					borderTop: `1px solid ${grey['200']}`,
				},
				{ ...props.style },
			]}
			className={`dividerComponent${' '} + ${props.className || ''}`}
		/>
	)
}
